<template>
  <transition name="fade">
    <div v-if="show" class="popup_box" style="display: block" @click.self="show = false">
      <div class="popup delete_category">
        <span class="page_title">Удалить отправителя [{{sender_on_delete.id}}] {{sender_on_delete.name}}  ?</span>
        <span class="close_popup" @click="close()"></span>
        <button class="btn" @click="close()">Отмена</button>
        <button class="btn empty" @click="confirm()">Удалить</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'DeleteSenderModal',
  computed: {
    ...mapState('senders', ['sender_on_delete', 'show_sender_delete_modal']),
    show: {
      get () {
        return this.show_sender_delete_modal
      },
      set (value) {
        this.setShowSenderDeleteModal(value)
      }
    }
  },
  methods: {
    ...mapActions('senders', ['deleteSender']),
    ...mapMutations('senders', ['setShowSenderDeleteModal', 'setSenderOnDelete']),
    close () {
      this.setSenderOnDelete(null)
      this.show = false
    },
    confirm () {
      this.deleteSender(this.sender_on_delete.id)
      this.close()
    }
  }
}
</script>

<style scoped>

</style>
